import { IIconProps } from '~/types';

const DoubleArrowIcon = ({ fill = '#7B7986', ...props }: IIconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m16 14-4 4-4-4m0-4 4-4 4 4"
      stroke="#141414"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default DoubleArrowIcon;
